import axios from 'axios';
import { apiUrl } from '../Config';

const getAuthToken = () => {
    return localStorage.getItem('token') || localStorage.getItem('authToken');
};

export const getAllSkills = async (limit = 10) => {
    try {
        const token = getAuthToken();
        const response = await axios.get(`${apiUrl}/skills/getAllskills?limit=${limit}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching skills:', error);
        throw error;
    }
};

export const searchSkillsApi = async (query) => {
    try {
        const token = getAuthToken();
        const response = await axios.get(`${apiUrl}/skills/searchByName?q=${encodeURIComponent(query)}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error searching skills:', error);
        throw error;
    }
};
